export class CreateApplicationApplicantEhmsConstants {
    static MARK_APPLICANT_DETAILS_AS_NOT_APPLICABLE_LABEL = "Capture applicant details?";
    static APPLICANT_FORMCONTROL_NAME = "applicantRecipient";
    static MARK_APPLICANT_DETAILS_AS_NOT_APPLICABLE_FORMCONTROL_NAME = "markApplicantDetailsAsNotApplicable";
}
